import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { BRAND } from '../constants/brand';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-24 md:py-28 w-full">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-brand-violet hover:text-slate-900 mb-10 transition-colors"
        >
          <FiArrowLeft />
          Back to home
        </Link>
        <h1 className="font-display text-4xl font-bold text-slate-900 mb-2">Privacy Policy</h1>
        <p className="text-slate-500 text-sm mb-10">Last updated: {new Date().getFullYear()}</p>

        <div className="prose prose-sm max-w-none text-slate-600 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Introduction</h2>
            <p>
              {BRAND.name} (“we,” “our,” or “us”) respects your privacy. This policy describes how we
              collect, use, and protect personal information when you use our website and services
              related to IT solutions and professional services for business clients.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Information we collect</h2>
            <p>We may collect contact details you submit (name, email, phone, company), technical data such as IP address and device information, and communications you send us.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">How we use information</h2>
            <p>We use this information to respond to inquiries, deliver services, improve our website, comply with law, and protect our legitimate business interests.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Retention & security</h2>
            <p>We retain data only as long as needed for the purposes above and implement reasonable safeguards. No method of transmission over the Internet is completely secure.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Your rights</h2>
            <p>Depending on your location, you may have rights to access, correct, or delete personal data. Contact us using the details below.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Contact</h2>
            <p>
              Questions:{' '}
              <a href={`mailto:${BRAND.contact.email}`} className="text-brand-violet hover:underline">
                {BRAND.contact.email}
              </a>
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
